import styled from 'styled-components';

export const StyledMark = styled.mark`
  background-color: transparent;
  color: inherit;
  font-weight: 700;
`;
